import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { Organization, VerifySessionResponse } from '@ui/interfaces'
import axiosInstance from '@ui/lib/api/axiosHelper'
import { useAuth } from '@ui/providers/AuthProvider'

export const useDemoNavigation = () => {
  const [organizations, setOrganizations] = useState<Organization[]>([])

  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    axiosInstance
      .get('/v1/organizations')
      .then((response) => {
        setOrganizations(response.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  return () => {
    const demoOrganization = organizations.find((org) => org.slug === 'datable-demo')
    if (demoOrganization) {
      auth.setOrganization(demoOrganization.id, (err: unknown, response?: VerifySessionResponse) => {
        if (err) {
          console.error('Error setting organization:', err)
          return
        }
        if (!response) {
          console.error('No response from setting organization')
          return
        }
        const { instance } = response
        if (instance) {
          navigate(`/instances/${instance.connect_key}/explore/events`)
        }
      })
    }
  }
}
